// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================= */
/* NAVBAR COMPONENT STYLES — PROFESSIONAL       */
/* ============================================= */

.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.25rem;
  height: 64px;
  background: white;
  border-bottom: 1px solid #E5E7EB;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 30;
  transition: background 250ms ease, border-color 250ms ease, box-shadow 250ms ease;
  gap: 1rem;
}

.navbar-dark {
  background: #1E293B;
  border-bottom-color: #334155;
}

/* ---- Sections ---- */
.navbar-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.navbar-section-left {
  flex: 0 1 auto;
  min-width: 0;
}

.navbar-section-right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* ---- Mobile Menu Button ---- */
.navbar-menu-btn {
  display: none;
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  color: #64748B;
  transition: all 150ms ease;
  align-items: center;
  justify-content: center;
}

.navbar-dark .navbar-menu-btn { color: #CBD5E1; }
.navbar-menu-btn:hover { background: #F1F5F9; color: #0F172A; }
.navbar-dark .navbar-menu-btn:hover { background: #334155; color: #F8FAFC; }

.navbar-menu-icon {
  width: 1.375rem;
  height: 1.375rem;
}

/* ---- Breadcrumb / Page Title ---- */
.navbar-breadcrumb {
  display: none;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

.navbar-breadcrumb-greeting {
  font-size: 0.6875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  line-height: 1;
  margin-bottom: 2px;
}

.navbar-breadcrumb-path {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.navbar-breadcrumb-root {
  font-size: 0.8125rem;
  font-weight: 400;
}

.navbar-breadcrumb-separator {
  width: 0.75rem;
  height: 0.75rem;
  flex-shrink: 0;
}

.navbar-breadcrumb-current {
  font-size: 0.8125rem;
  font-weight: 600;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---- Center Search ---- */
.navbar-center {
  flex: 1 1 auto;
  display: none;
  justify-content: center;
  max-width: 420px;
  margin: 0 auto;
}

button.navbar-search {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: 0.625rem;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  transition: all 200ms ease;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
}

button.navbar-search:hover {
  border-color: var(--app-primary-color, #26256b);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);
  background: white;
}

.navbar-dark button.navbar-search:hover {
  background: #0F172A;
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.1);
}

.navbar-search-icon {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}

.navbar-search-input {
  flex: 1 1;
  background: transparent;
  font-size: 0.8125rem;
  font-weight: 400;
  color: inherit;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
}

.navbar-search-shortcut {
  display: none;
  font-size: 0.625rem;
  font-weight: 600;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  border: 1px solid #E2E8F0;
  background: #F1F5F9;
  line-height: 1.3;
  white-space: nowrap;
  font-family: system-ui, sans-serif;
}

/* ---- Action Buttons ---- */
.navbar-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.navbar-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0.5rem;
  border: none;
  border-radius: 0.5rem;
  background: transparent;
  cursor: pointer;
  color: #64748B;
  transition: all 160ms cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.navbar-action-btn::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 0.5rem;
  background: currentColor;
  opacity: 0;
  transition: opacity 160ms ease;
}

.navbar-action-btn:hover::after {
  opacity: 0.07;
}

.navbar-action-btn:active {
  transform: scale(0.92);
}

.navbar-dark .navbar-action-btn { color: #94A3B8; }

.navbar-action-btn:hover {
  background: #F1F5F9;
  color: #1E293B;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.navbar-dark .navbar-action-btn:hover {
  background: #334155;
  color: #F1F5F9;
  box-shadow: 0 2px 8px rgba(0,0,0,0.25);
}

.navbar-action-btn[title*='Dark']:hover,
.navbar-action-btn[title*='Light']:hover {
  color: #F59E0B;
}

.navbar-dark .navbar-action-btn[title*='Dark']:hover,
.navbar-dark .navbar-action-btn[title*='Light']:hover {
  color: #FBBF24;
}

.navbar-action-icon {
  width: 1.25rem;
  height: 1.25rem;
  transition: transform 160ms cubic-bezier(0.4, 0, 0.2, 1);
}

.navbar-action-btn:hover .navbar-action-icon {
  transform: scale(1.12);
}

@keyframes dot-ping {
  0%   { transform: scale(1); opacity: 1; }
  60%  { transform: scale(2.2); opacity: 0; }
  100% { transform: scale(2.2); opacity: 0; }
}

/* Notification dot */
.navbar-notification-btn {
  position: relative;
}

.navbar-notification-dot {
  position: absolute;
  top: 0.375rem;
  right: 0.375rem;
  width: 0.4375rem;
  height: 0.4375rem;
  border-radius: 9999px;
  border: 1.5px solid white;
}

.navbar-notification-dot::before {
  content: '';
  position: absolute;
  inset: -1px;
  border-radius: 9999px;
  background: inherit;
  animation: dot-ping 2.2s cubic-bezier(0, 0, 0.2, 1) infinite;
}

.navbar-dark .navbar-notification-dot {
  border-color: #1E293B;
}

/* ---- Divider ---- */
.navbar-divider {
  width: 1px;
  height: 1.75rem;
  background: #E5E7EB;
  margin: 0 0.375rem;
  flex-shrink: 0;
}

.navbar-dark .navbar-divider { background: #334155; }

/* ---- User Profile ---- */
.navbar-user-profile {
  position: relative;
}

.navbar-user-trigger {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.3125rem 0.5rem 0.3125rem 0.3125rem;
  border: 1px solid transparent;
  border-radius: 0.625rem;
  background: transparent;
  cursor: pointer;
  transition: all 160ms cubic-bezier(0.4, 0, 0.2, 1);
}

.navbar-user-trigger:hover {
  background: #F8FAFC;
  border-color: #E5E7EB;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.navbar-user-trigger:active {
  transform: scale(0.97);
}

.navbar-dark .navbar-user-trigger:hover {
  background: #334155;
  border-color: #475569;
  box-shadow: 0 2px 10px rgba(0,0,0,0.25);
}

.navbar-user-avatar {
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.navbar-user-trigger:hover .navbar-user-avatar {
  transform: scale(1.07);
  box-shadow: 0 3px 10px rgba(0,0,0,0.18);
}

.navbar-user-avatar-text {
  font-size: 0.6875rem;
  font-weight: 700;
  color: white;
  letter-spacing: 0.04em;
  line-height: 1;
}

.navbar-user-info {
  display: none;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  text-align: left;
}

.navbar-user-name {
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-user-role-label {
  font-size: 0.6875rem;
  font-weight: 400;
  line-height: 1.25;
  text-transform: capitalize;
}

.navbar-user-chevron {
  display: none;
  flex-shrink: 0;
  transition: transform 200ms ease;
}

/* ═══════════════════════════════════════════
   USER DROPDOWN — slim & neat
   ═══════════════════════════════════════════ */
.navbar-user-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  min-width: 230px;
  border-radius: 0.75rem;
  border: 1px solid #E2E8F0;
  overflow: hidden;
  z-index: 200;
  box-shadow:
    0 4px 16px rgba(0,0,0,0.08),
    0 1px 4px rgba(0,0,0,0.04);
}

/* ── Header ── */
.navbar-dropdown-header {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.75rem 0.875rem;
  border-bottom: 1px solid #F1F5F9;
}

.navbar-dropdown-avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.navbar-dropdown-avatar {
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6875rem;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}

.navbar-dropdown-avatar-online {
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  border: 1.5px solid white;
}

.navbar-dark .navbar-dropdown-avatar-online {
  border-color: #0F172A;
}

.navbar-dropdown-user-meta {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

.navbar-dropdown-name {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-dropdown-email {
  margin: 0;
  font-size: 0.6875rem;
  font-weight: 400;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}

.navbar-dropdown-role-badge {
  display: inline-flex;
  align-items: center;
  margin-top: 0.2rem;
  padding: 0.1rem 0.4rem;
  border-radius: 9999px;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  line-height: 1.6;
}

/* ── Body ── */
.navbar-dropdown-body {
  padding: 0.3rem;
}

.navbar-dropdown-footer {
  padding: 0.3rem;
  border-top: 1px solid #F1F5F9;
}

.navbar-dark .navbar-dropdown-footer {
  border-top-color: #1E293B;
}

/* ── Items ── */
.navbar-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.4rem 0.6rem;
  border: none;
  border-radius: 0.5rem;
  background: transparent;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: background 130ms ease;
  text-align: left;
}

.navbar-dropdown-item:hover {
  background: #F1F5F9;
}

.navbar-dark .navbar-dropdown-item:hover {
  background: #1E293B;
}

/* Icon — bare, no wrap box */
.navbar-dropdown-item-icon-wrap {
  display: contents; /* unwrap — icon renders inline */
}

.navbar-dropdown-item-icon-danger {
  display: contents;
}

.navbar-dropdown-item-icon {
  width: 0.875rem;
  height: 0.875rem;
  flex-shrink: 0;
  opacity: 0.55;
  transition: opacity 130ms ease;
}

.navbar-dropdown-item:hover .navbar-dropdown-item-icon {
  opacity: 0.85;
}

.navbar-dropdown-item-danger .navbar-dropdown-item-icon {
  opacity: 0.8;
  color: #EF4444;
}

.navbar-dropdown-item-label {
  flex: 1 1;
}

/* Slim chevron arrow */
.navbar-dropdown-item-arrow {
  font-size: 0.875rem;
  line-height: 1;
  opacity: 0;
  color: #cbd5e1;
  transition: opacity 130ms ease;
}

.navbar-dropdown-item:hover .navbar-dropdown-item-arrow {
  opacity: 1;
}

/* Danger */
.navbar-dropdown-item-danger {
  color: #EF4444 !important;
}

.navbar-dropdown-item-danger:hover {
  background: #FEF2F2 !important;
}

.navbar-dark .navbar-dropdown-item-danger:hover {
  background: rgba(239,68,68,0.1) !important;
}

.navbar-dropdown-item-danger:hover {
  background: #FEF2F2 !important;
  box-shadow: inset 0 0 0 1px rgba(239,68,68,0.1) !important;
}

.navbar-dark .navbar-dropdown-item-danger:hover {
  background: rgba(239, 68, 68, 0.1) !important;
  box-shadow: inset 0 0 0 1px rgba(239,68,68,0.15) !important;
}

/* ============================================= */
/* RESPONSIVE BREAKPOINTS                        */
/* ============================================= */

@media (min-width: 640px) {
  .navbar-breadcrumb {
    display: flex;
  }

  .navbar-breadcrumb-greeting {
    display: none;
  }
}

@media (min-width: 768px) {
  .navbar {
    padding: 0 1.5rem;
    /* left offset from Layout.js dynamic style */
  }
}

@media (min-width: 1024px) {
  .navbar {
    padding: 0 2rem;
  }

  .navbar-breadcrumb-greeting {
    display: block;
  }

  .navbar-center {
    display: flex;
  }

  .navbar-search-shortcut {
    display: inline-flex;
  }

  .navbar-user-info {
    display: flex;
  }

  .navbar-user-chevron {
    display: block;
  }
}

/* ── Corporate navbar — subtle brand connection to sidebar ── */
.navbar-layout-corporate {
}

.navbar-layout-corporate::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(var(--app-primary-rgb, 38, 37, 107), 0.22) 0%,
    rgba(var(--app-primary-rgb, 38, 37, 107), 0.06) 30%,
    transparent 60%
  );
  pointer-events: none;
}

.navbar-dark.navbar-layout-corporate::after {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.08) 0%,
    rgba(255, 255, 255, 0.03) 30%,
    transparent 60%
  );
}

@media (max-width: 767px) {
  .navbar {
    padding: 0 0.75rem;
  }

  .navbar-menu-btn {
    display: flex;
  }

  .navbar-breadcrumb {
    display: none;
  }

  .navbar-center {
    display: none;
  }

  .navbar-divider {
    display: none;
  }

  .navbar-action-btn {
    padding: 0.4375rem;
  }

  .navbar-action-icon {
    width: 1.125rem;
    height: 1.125rem;
  }

  .navbar-user-info {
    display: none;
  }

  .navbar-user-chevron {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/Navbar.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,iDAAiD;AACjD,kDAAkD;;AAElD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iFAAiF;EACjF,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gCAAgC,cAAc,EAAE;AAChD,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,sCAAsC,mBAAmB,EAAE,cAAc,EAAE;;AAE3E;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,wBAAwB;EACxB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kCAAkC,cAAc,EAAE;;AAElD;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,OAAO,mBAAmB,EAAE,UAAU,EAAE;EACxC,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,OAAO,qBAAqB,EAAE,UAAU,EAAE;AAC5C;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,+BAA+B,mBAAmB,EAAE;;AAEpD,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA;;gDAEgD;AAChD;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ;;8BAE4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB,EAAE,iCAAiC;AACtD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,0DAA0D;AAC5D;;AAEA;EACE,6CAA6C;EAC7C,2DAA2D;AAC7D;;AAEA,kDAAkD;AAClD,kDAAkD;AAClD,kDAAkD;;AAElD;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,gEAAgE;AAChE;AACA;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX;;;;;GAKC;EACD,oBAAoB;AACtB;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================================= */\n/* NAVBAR COMPONENT STYLES — PROFESSIONAL       */\n/* ============================================= */\n\n.navbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1.25rem;\n  height: 64px;\n  background: white;\n  border-bottom: 1px solid #E5E7EB;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 30;\n  transition: background 250ms ease, border-color 250ms ease, box-shadow 250ms ease;\n  gap: 1rem;\n}\n\n.navbar-dark {\n  background: #1E293B;\n  border-bottom-color: #334155;\n}\n\n/* ---- Sections ---- */\n.navbar-section {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.navbar-section-left {\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\n.navbar-section-right {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* ---- Mobile Menu Button ---- */\n.navbar-menu-btn {\n  display: none;\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  color: #64748B;\n  transition: all 150ms ease;\n  align-items: center;\n  justify-content: center;\n}\n\n.navbar-dark .navbar-menu-btn { color: #CBD5E1; }\n.navbar-menu-btn:hover { background: #F1F5F9; color: #0F172A; }\n.navbar-dark .navbar-menu-btn:hover { background: #334155; color: #F8FAFC; }\n\n.navbar-menu-icon {\n  width: 1.375rem;\n  height: 1.375rem;\n}\n\n/* ---- Breadcrumb / Page Title ---- */\n.navbar-breadcrumb {\n  display: none;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n}\n\n.navbar-breadcrumb-greeting {\n  font-size: 0.6875rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  line-height: 1;\n  margin-bottom: 2px;\n}\n\n.navbar-breadcrumb-path {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.navbar-breadcrumb-root {\n  font-size: 0.8125rem;\n  font-weight: 400;\n}\n\n.navbar-breadcrumb-separator {\n  width: 0.75rem;\n  height: 0.75rem;\n  flex-shrink: 0;\n}\n\n.navbar-breadcrumb-current {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ---- Center Search ---- */\n.navbar-center {\n  flex: 1 1 auto;\n  display: none;\n  justify-content: center;\n  max-width: 420px;\n  margin: 0 auto;\n}\n\nbutton.navbar-search {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.625rem;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  transition: all 200ms ease;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n}\n\nbutton.navbar-search:hover {\n  border-color: var(--app-primary-color, #26256b);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);\n  background: white;\n}\n\n.navbar-dark button.navbar-search:hover {\n  background: #0F172A;\n  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.1);\n}\n\n.navbar-search-icon {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n}\n\n.navbar-search-input {\n  flex: 1;\n  background: transparent;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  color: inherit;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  pointer-events: none;\n}\n\n.navbar-search-shortcut {\n  display: none;\n  font-size: 0.625rem;\n  font-weight: 600;\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n  border: 1px solid #E2E8F0;\n  background: #F1F5F9;\n  line-height: 1.3;\n  white-space: nowrap;\n  font-family: system-ui, sans-serif;\n}\n\n/* ---- Action Buttons ---- */\n.navbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.navbar-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 0.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  background: transparent;\n  cursor: pointer;\n  color: #64748B;\n  transition: all 160ms cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.navbar-action-btn::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 0.5rem;\n  background: currentColor;\n  opacity: 0;\n  transition: opacity 160ms ease;\n}\n\n.navbar-action-btn:hover::after {\n  opacity: 0.07;\n}\n\n.navbar-action-btn:active {\n  transform: scale(0.92);\n}\n\n.navbar-dark .navbar-action-btn { color: #94A3B8; }\n\n.navbar-action-btn:hover {\n  background: #F1F5F9;\n  color: #1E293B;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n\n.navbar-dark .navbar-action-btn:hover {\n  background: #334155;\n  color: #F1F5F9;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.25);\n}\n\n.navbar-action-btn[title*='Dark']:hover,\n.navbar-action-btn[title*='Light']:hover {\n  color: #F59E0B;\n}\n\n.navbar-dark .navbar-action-btn[title*='Dark']:hover,\n.navbar-dark .navbar-action-btn[title*='Light']:hover {\n  color: #FBBF24;\n}\n\n.navbar-action-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  transition: transform 160ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.navbar-action-btn:hover .navbar-action-icon {\n  transform: scale(1.12);\n}\n\n@keyframes dot-ping {\n  0%   { transform: scale(1); opacity: 1; }\n  60%  { transform: scale(2.2); opacity: 0; }\n  100% { transform: scale(2.2); opacity: 0; }\n}\n\n/* Notification dot */\n.navbar-notification-btn {\n  position: relative;\n}\n\n.navbar-notification-dot {\n  position: absolute;\n  top: 0.375rem;\n  right: 0.375rem;\n  width: 0.4375rem;\n  height: 0.4375rem;\n  border-radius: 9999px;\n  border: 1.5px solid white;\n}\n\n.navbar-notification-dot::before {\n  content: '';\n  position: absolute;\n  inset: -1px;\n  border-radius: 9999px;\n  background: inherit;\n  animation: dot-ping 2.2s cubic-bezier(0, 0, 0.2, 1) infinite;\n}\n\n.navbar-dark .navbar-notification-dot {\n  border-color: #1E293B;\n}\n\n/* ---- Divider ---- */\n.navbar-divider {\n  width: 1px;\n  height: 1.75rem;\n  background: #E5E7EB;\n  margin: 0 0.375rem;\n  flex-shrink: 0;\n}\n\n.navbar-dark .navbar-divider { background: #334155; }\n\n/* ---- User Profile ---- */\n.navbar-user-profile {\n  position: relative;\n}\n\n.navbar-user-trigger {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.3125rem 0.5rem 0.3125rem 0.3125rem;\n  border: 1px solid transparent;\n  border-radius: 0.625rem;\n  background: transparent;\n  cursor: pointer;\n  transition: all 160ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.navbar-user-trigger:hover {\n  background: #F8FAFC;\n  border-color: #E5E7EB;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n\n.navbar-user-trigger:active {\n  transform: scale(0.97);\n}\n\n.navbar-dark .navbar-user-trigger:hover {\n  background: #334155;\n  border-color: #475569;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.25);\n}\n\n.navbar-user-avatar {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n  transition: transform 160ms ease, box-shadow 160ms ease;\n}\n\n.navbar-user-trigger:hover .navbar-user-avatar {\n  transform: scale(1.07);\n  box-shadow: 0 3px 10px rgba(0,0,0,0.18);\n}\n\n.navbar-user-avatar-text {\n  font-size: 0.6875rem;\n  font-weight: 700;\n  color: white;\n  letter-spacing: 0.04em;\n  line-height: 1;\n}\n\n.navbar-user-info {\n  display: none;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n  text-align: left;\n}\n\n.navbar-user-name {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.navbar-user-role-label {\n  font-size: 0.6875rem;\n  font-weight: 400;\n  line-height: 1.25;\n  text-transform: capitalize;\n}\n\n.navbar-user-chevron {\n  display: none;\n  flex-shrink: 0;\n  transition: transform 200ms ease;\n}\n\n/* ═══════════════════════════════════════════\n   USER DROPDOWN — slim & neat\n   ═══════════════════════════════════════════ */\n.navbar-user-dropdown {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  right: 0;\n  min-width: 230px;\n  border-radius: 0.75rem;\n  border: 1px solid #E2E8F0;\n  overflow: hidden;\n  z-index: 200;\n  box-shadow:\n    0 4px 16px rgba(0,0,0,0.08),\n    0 1px 4px rgba(0,0,0,0.04);\n}\n\n/* ── Header ── */\n.navbar-dropdown-header {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.75rem 0.875rem;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.navbar-dropdown-avatar-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.navbar-dropdown-avatar {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  color: white;\n  flex-shrink: 0;\n}\n\n.navbar-dropdown-avatar-online {\n  position: absolute;\n  bottom: -1px;\n  right: -1px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #22c55e;\n  border: 1.5px solid white;\n}\n\n.navbar-dark .navbar-dropdown-avatar-online {\n  border-color: #0F172A;\n}\n\n.navbar-dropdown-user-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n}\n\n.navbar-dropdown-name {\n  margin: 0;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1.3;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.navbar-dropdown-email {\n  margin: 0;\n  font-size: 0.6875rem;\n  font-weight: 400;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 150px;\n}\n\n.navbar-dropdown-role-badge {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 0.2rem;\n  padding: 0.1rem 0.4rem;\n  border-radius: 9999px;\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  line-height: 1.6;\n}\n\n/* ── Body ── */\n.navbar-dropdown-body {\n  padding: 0.3rem;\n}\n\n.navbar-dropdown-footer {\n  padding: 0.3rem;\n  border-top: 1px solid #F1F5F9;\n}\n\n.navbar-dark .navbar-dropdown-footer {\n  border-top-color: #1E293B;\n}\n\n/* ── Items ── */\n.navbar-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.4rem 0.6rem;\n  border: none;\n  border-radius: 0.5rem;\n  background: transparent;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 500;\n  transition: background 130ms ease;\n  text-align: left;\n}\n\n.navbar-dropdown-item:hover {\n  background: #F1F5F9;\n}\n\n.navbar-dark .navbar-dropdown-item:hover {\n  background: #1E293B;\n}\n\n/* Icon — bare, no wrap box */\n.navbar-dropdown-item-icon-wrap {\n  display: contents; /* unwrap — icon renders inline */\n}\n\n.navbar-dropdown-item-icon-danger {\n  display: contents;\n}\n\n.navbar-dropdown-item-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n  flex-shrink: 0;\n  opacity: 0.55;\n  transition: opacity 130ms ease;\n}\n\n.navbar-dropdown-item:hover .navbar-dropdown-item-icon {\n  opacity: 0.85;\n}\n\n.navbar-dropdown-item-danger .navbar-dropdown-item-icon {\n  opacity: 0.8;\n  color: #EF4444;\n}\n\n.navbar-dropdown-item-label {\n  flex: 1;\n}\n\n/* Slim chevron arrow */\n.navbar-dropdown-item-arrow {\n  font-size: 0.875rem;\n  line-height: 1;\n  opacity: 0;\n  color: #cbd5e1;\n  transition: opacity 130ms ease;\n}\n\n.navbar-dropdown-item:hover .navbar-dropdown-item-arrow {\n  opacity: 1;\n}\n\n/* Danger */\n.navbar-dropdown-item-danger {\n  color: #EF4444 !important;\n}\n\n.navbar-dropdown-item-danger:hover {\n  background: #FEF2F2 !important;\n}\n\n.navbar-dark .navbar-dropdown-item-danger:hover {\n  background: rgba(239,68,68,0.1) !important;\n}\n\n.navbar-dropdown-item-danger:hover {\n  background: #FEF2F2 !important;\n  box-shadow: inset 0 0 0 1px rgba(239,68,68,0.1) !important;\n}\n\n.navbar-dark .navbar-dropdown-item-danger:hover {\n  background: rgba(239, 68, 68, 0.1) !important;\n  box-shadow: inset 0 0 0 1px rgba(239,68,68,0.15) !important;\n}\n\n/* ============================================= */\n/* RESPONSIVE BREAKPOINTS                        */\n/* ============================================= */\n\n@media (min-width: 640px) {\n  .navbar-breadcrumb {\n    display: flex;\n  }\n\n  .navbar-breadcrumb-greeting {\n    display: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar {\n    padding: 0 1.5rem;\n    /* left offset from Layout.js dynamic style */\n  }\n}\n\n@media (min-width: 1024px) {\n  .navbar {\n    padding: 0 2rem;\n  }\n\n  .navbar-breadcrumb-greeting {\n    display: block;\n  }\n\n  .navbar-center {\n    display: flex;\n  }\n\n  .navbar-search-shortcut {\n    display: inline-flex;\n  }\n\n  .navbar-user-info {\n    display: flex;\n  }\n\n  .navbar-user-chevron {\n    display: block;\n  }\n}\n\n/* ── Corporate navbar — subtle brand connection to sidebar ── */\n.navbar-layout-corporate {\n}\n\n.navbar-layout-corporate::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  background: linear-gradient(\n    90deg,\n    rgba(var(--app-primary-rgb, 38, 37, 107), 0.22) 0%,\n    rgba(var(--app-primary-rgb, 38, 37, 107), 0.06) 30%,\n    transparent 60%\n  );\n  pointer-events: none;\n}\n\n.navbar-dark.navbar-layout-corporate::after {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.08) 0%,\n    rgba(255, 255, 255, 0.03) 30%,\n    transparent 60%\n  );\n}\n\n@media (max-width: 767px) {\n  .navbar {\n    padding: 0 0.75rem;\n  }\n\n  .navbar-menu-btn {\n    display: flex;\n  }\n\n  .navbar-breadcrumb {\n    display: none;\n  }\n\n  .navbar-center {\n    display: none;\n  }\n\n  .navbar-divider {\n    display: none;\n  }\n\n  .navbar-action-btn {\n    padding: 0.4375rem;\n  }\n\n  .navbar-action-icon {\n    width: 1.125rem;\n    height: 1.125rem;\n  }\n\n  .navbar-user-info {\n    display: none;\n  }\n\n  .navbar-user-chevron {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
